<template>
  <b-modal
    v-model="showInviteModal"
    id="modal-invite-candidate"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
  >
    <b-overlay
      :show="isLoading"
      spinner-variant="primary"
      color="#fff"
      rounded="lg"
    >
      <div class="modal__header">
        <h3>
          Запросити <span v-if="role == 'user'">випускника</span>
          <span v-if="role == 'admin'">адміністратора</span>
        </h3>
        <p>
          Випускник отримає <strong>СМС</strong> із згенерованим паролем для
          входу, який потім зможе замінити на власний
        </p>
      </div>
      <div class="modal__content">
        <div class="form-input">
          <label class="d-block"> E-mail </label>
          <small> Для входу в ос. кабінет </small>
          <b-form-input v-model="new_user.email" type="email"></b-form-input>
        </div>
        <div class="form-input">
          <label class="d-block"> Номер телефону </label>
          <small>
            На цей номер буде надіслано запрошення із тимчасовим паролем</small
          >
          <vue-tel-input
            @validate="validatePhone"
            v-model="new_user.phone"
          ></vue-tel-input>
        </div>
      </div>
      <div class="modal__footer px-1">
        <b-alert :show="inviteError.show" variant="danger">
          {{ inviteError.text }}
        </b-alert>
        <b-button
          :disabled="buttonDisabled"
          @click="sendInvite"
          variant="primary"
          class="w-100"
        >
          Надіслати запрошення
        </b-button>
        <b-button
          @click="showInviteModal = false"
          variant="outline-danger"
          class="w-100 mt-2"
        >
          Скасувати
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
  props: ["role"],
  data() {
    return {
      isLoading: false,
      showInviteModal: false,
      inviteError: {
        show: false,
        text: "",
      },
      phoneValid: false,

      new_user: {
        email: "",
        phone: "",
        formattedPhone: "",
      },

      invite_errors: [
        {
          code: "auth/email-already-exists",
          text: "Користувач з таким email вже існує",
        },
        {
          code: "auth/invalid-email",
          text: "Email має неправильний формат",
        },
      ],
    };
  },
  computed: {
    buttonDisabled() {
      let disabled = false;
      if (!this.phoneValid || this.new_user.email.indexOf("@") < 0) {
        disabled = true;
      }
      return disabled;
    },
  },
  methods: {
    async sendInvite() {
      this.isLoading = true;
      this.inviteError.show = false;
      this.inviteError.text = "";
      let data = Object.assign({}, this.new_user);
      data["role"] = this.role;
      data.phone = this.new_user.formattedPhone;

      let result = await this.$api
        .post("/user/invite/", data)
        .then((data) => {
          return data.data;
        })
        .catch((error) => {
          return error;
        });
      this.isLoading = false;
      console.log(result);
      if (result.success || result.code == "success") {
        this.showInviteModal = false;
        this.new_user = {
          email: "",
          phone: "",
          formattedPhone: "",
        };
        this.$toast.success("Запрошення надіслано");
      } else {
        let errorCode = result.error.error.code;
        let errorCase = this.invite_errors.find((el) => {
          return el.code == errorCode;
        });
        this.inviteError.show = true;
        this.inviteError.text = errorCase.text;
        this.$toast.error("Щось пішло не так");
      }
    },
    validatePhone(value) {
      console.log(value);
      if (value.valid) {
        this.new_user.formattedPhone = value.number;
        this.phoneValid = true;
      } else {
        this.phoneValid = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-input {
  padding-bottom: 20px;
  label {
    margin-bottom: 0;
    line-height: 1;
  }
  small {
    font-size: 13px;
    color: #999;
    margin-bottom: 6px;
    display: block;
  }
}
</style>
